import { DocumentLoader as DocumentLoaderComp } from './component'
import { DocumentLoader as DocumentLoaderCont } from './container'

export default DocumentLoaderCont
export { DocumentLoaderCont, DocumentLoaderComp }
